import React, { FC } from "react";
import { Theme } from "@material-ui/core/styles";
import { styled } from "@material-ui/styles";

import { PrimaryButton } from "../../elements/Button";

type AdvertisersToolbarProps = {
  onNewAdvertiser: () => void;
  showArchived: boolean;
  onToggleShowArchived: () => void;
};

const Root = styled("div")({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  marginBottom: 12,
});

const LeftGroup = styled("div")({
  display: "flex",
  gap: 8,
  alignItems: "center",
});

const ToggleLabel = styled("label")(({ theme }: { theme: Theme }) => ({
  display: "flex",
  alignItems: "center",
  gap: 6,
  fontSize: 13,
  fontWeight: 500,
  color: theme.palette.brand.gray500,
  cursor: "pointer",
  userSelect: "none",
}));

const PlusIcon = () => (
  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <line x1="12" y1="5" x2="12" y2="19" />
    <line x1="5" y1="12" x2="19" y2="12" />
  </svg>
);

const AdvertisersToolbar: FC<AdvertisersToolbarProps> = ({ onNewAdvertiser, showArchived, onToggleShowArchived }) => (
  <Root>
    <LeftGroup>
      <ToggleLabel>
        <input type="checkbox" checked={showArchived} onChange={onToggleShowArchived} />
        Show archived
      </ToggleLabel>
    </LeftGroup>

    <PrimaryButton type="button" onClick={onNewAdvertiser}>
      <PlusIcon />
      New Advertiser
    </PrimaryButton>
  </Root>
);

export default AdvertisersToolbar;
